import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MessageBox from '../components/MessageBox';
import * as rules from '../utils/ValidationPassword';

export default class PasswordValidation extends Component {

    static propTypes = {
        lang: PropTypes.string.isRequired,
        password1: PropTypes.string.isRequired,
        password2: PropTypes.string.isRequired
    };


    render() {
        let password1 = this.props.password1;
        let password2 = this.props.password2;
        let warning = rules.validateMatch(password1, password2) ? '' : <MessageBox lang={this.props.lang}
                                                mType="warning" mKey="pmatch" mIcon="exclamation-sign" />;
        let lenWarning = rules.validateLength(password1, 8) ? '' : <MessageBox lang={this.props.lang}
                                                mType="warning" mKey="plen" mIcon="exclamation-sign" />;
        let charWarning = rules.validateCharExists(password1) ? '' : <MessageBox lang={this.props.lang}
                                                mType="warning" mKey="pchar" mIcon="exclamation-sign" />;

        let digitWarning = rules.validateDigitExists(password1) ? '' : <MessageBox lang={this.props.lang}
                                                mType="warning" mKey="pdigit" mIcon="exclamation-sign" />;

        return (
            <div>
            {charWarning}
            {digitWarning}
            {lenWarning}
            {warning}
            </div>
            );
  }
}
